import { Observable, map } from "rxjs";
import { WebServicesService } from "../webservices.service";
import { SelectSearchData } from "src/app/shared/select-search/select-search.data";
import { ApiService } from "./_api.service";
import { Article, ArticleCalendar, ArticleCalendarDetail } from "src/app/_models/article";
import { environment } from 'src/environments/environment';

export class ArticleApiService {
    constructor(private _ws: WebServicesService) {}

    // Article methods
    get(): Observable<Article[]> {
        return this._ws.getWithCache(`${environment.wsBaseUrl}/api/Article/all`, ApiService.CACHEKEY_ARTICLES);
    }

    getSelect(): Observable<SelectSearchData[]> {
        return this._ws.getWithCache(`${environment.wsBaseUrl}/api/Article/selectAll`, ApiService.CACHEKEY_ARTICLES_SELECT);
    }

    getList(ids: number[]): Observable<string> {
        return this._ws.getCsvContent(`${environment.wsBaseUrl}/api/Article/list?${ids.map(id => `Id=${encodeURIComponent(id)}`).join('&')}`);
    }

    getOne(id: number): Observable<Article> {
        return this._ws.getWithoutCache(`${environment.wsBaseUrl}/api/Article/${encodeURIComponent(id)}`).pipe(
            map(art => {
                art.createdDateTime = new Date(art.createdDateTime);
                art.modifiedDateTime = new Date(art.modifiedDateTime);
                return art;
            })
        );
    }

    getWithAvailability(id: number, startDate: string, endDate: string): Observable<Article> {
        return this._ws.getWithoutCache(`${environment.wsBaseUrl}/api/Article/${encodeURIComponent(id)}/${encodeURIComponent(startDate)}/${encodeURIComponent(endDate)}`).pipe(
            map(art => {
                art.createdDateTime = new Date(art.createdDateTime);
                art.modifiedDateTime = new Date(art.modifiedDateTime);
                return art;
            })
        );
    }

    getWithAvailabilityExcludedCurrentDoc(id: number, startDate: string, endDate: string, docId: number): Observable<Article> {
        return this._ws.getWithoutCache(`${environment.wsBaseUrl}/api/Article/${encodeURIComponent(id)}/${encodeURIComponent(startDate)}/${encodeURIComponent(endDate)}/${encodeURIComponent(docId)}`).pipe(
            map(art => {
                art.createdDateTime = new Date(art.createdDateTime);
                art.modifiedDateTime = new Date(art.modifiedDateTime);
                return art;
            })
        );
    }

    put(article: Article) {
        return this._ws.putJson(`${environment.wsBaseUrl}/api/Article/${encodeURIComponent(article.id)}`, article);
    }

    post(article: Article): Observable<Article> {
        return this._ws.postJson(`${environment.wsBaseUrl}/api/Article/`, article);
    }

    delete(article: Article) {
        return this._ws.deleteHttp(`${environment.wsBaseUrl}/api/Article/${encodeURIComponent(article.id)}`);
    }

    getCalendar(date: string): Observable<ArticleCalendar> {
        return this._ws.getWithoutCache(`${environment.wsBaseUrl}/api/Article/Calendar/${encodeURIComponent(date)}`);
    }

    getCalendarDetail(date: string, articleId: number): Observable<ArticleCalendarDetail> {
        return this._ws.getWithoutCache(`${environment.wsBaseUrl}/api/Article/CalendarDetail/${encodeURIComponent(date)}/${encodeURIComponent(articleId)}`);
    }

    getCalendarList(date: string, ids: number[]): Observable<string> {
        return this._ws.getCsvContent(`${environment.wsBaseUrl}/api/Article/CalendarExport?date=${encodeURIComponent(date)}&${ids.map(id => `Id=${encodeURIComponent(id)}`).join('&')}`);
    }
}
